import { crossdockReceiptActions } from '../crossdockReceipt.state';
const tryUnblockReceiptItem = (item) => (dispatch) => {
    if (item.blockedQuantity === 0)
        return;
    const unblockItemData = { invoiceId: item.invoiceId, receiptItemId: item.receiptItemId, isBlocked: true };
    dispatch(crossdockReceiptActions.openRevokeReceiptItemDialog(unblockItemData));
};
export { tryUnblockReceiptItem };
